import { useEffect, useMemo, useState } from "react";

import classnames from "classnames";
import {
    Card,
    Col,
    Container,
    Media,
    Nav,
    NavItem,
    NavLink,
    Row
} from "reactstrap";

import "nouislider/distribute/nouislider.css";
import ViewIcon from "../../../../assets/images/viewicon.svg"
import tickIcon from "../../../../assets/images/tickIcon.svg"
import closeIcon from "../../../../assets/images/closeIcon.svg"
import PaginatedTable from "Components/Common/PaginatedTable";
import imageOrBuypass from "../../../../assets/images/buyPass-favicon.png";
import pdfImage from "../../../../assets/images/pdf.png"
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { createSelector } from "reselect";
import { Link } from "react-router-dom";
import { getSellerBrandThunk } from "../../../../live-slices/brands/thunk";
import { getBrands, getSellerBrands } from "helpers/backend_helper";
import BreadCrumb from "Components/Common/BreadCrumb";


const Brands = (props: any) => {
    const dispatch: any = useDispatch();

    const SelectotherPartner = createSelector(
        (state: any) => state.Brands,
        (sellerBrands) => sellerBrands?.sellerBrands
    );

    const selecteCountData = createSelector(
        (state: any) => state.Brands,
        (sellerBrands) => sellerBrands?.counts || { allCount: 0 }
    );

    const otherPartner = useSelector(SelectotherPartner);
    console.log(otherPartner, "hekmsd")
    const counts = useSelector(selecteCountData);
    console.log(otherPartner, "lissttt")
    const [tableKey, setTableKey] = useState(Date.now());
    const [otherPartnerList, setotherPartnerList] = useState<any>([]);
    const [activeTab, setActiveTab] = useState<any>("all");
    const [page, setPage] = useState(1);
    const [count, setCount] = useState(10);

    // useEffect(() => {
    //     dispatch(getSellerBrandThunk({status:activeTab,keyword:"",relation:""}));
    // }, [])

    useEffect(() => {
        setotherPartnerList(otherPartner);
        console.log("brand list", otherPartner)
    }, [otherPartner]);


    const toggleTab = (tab: any, type: any) => {
        if (activeTab !== tab) {
            dispatch(getSellerBrandThunk({ page: 1, count: 10, status: activeTab, keyword: "", relation: "" }))
                .unwrap()
            setTableKey(Date.now())
            setActiveTab(tab);
            setotherPartnerList(otherPartner);
        }
    };





    useEffect(() => {
        const sliderq = document.getElementById("product-price-range");
        sliderq?.setAttribute("data-slider-color", "success");
    }, []);


    const columns = useMemo(() => [
        {
            header: "Brand Image",
            accessorKey: "brandAuthenticationDocument",
            enableColumnFilter: false,
            cell: (row: any) => {
                const document = row.getValue();
                const imageUrl = document?.metaData?.fileType === "application/pdf"
                ? pdfImage
                : document?.url || imageOrBuypass;

                const imageAlt = document?.metaData?.name || "Brand Image";
                console.log(imageUrl, "Image URL");
                console.log(document, "Document Object");
                return (
                    <img
                        src={imageUrl}
                        alt={imageAlt}
                        style={{
                            width: "50px",
                            height: "50px",
                            objectFit: "cover",
                            borderRadius: "4px",
                        }}
                    />
                );
            },
        },

        {
            header: "Brand Name",
            accessorKey: "name",
            enableColumnFilter: false,
            cell: ({ getValue }) => {
                const name = getValue();
                return name ? name?.charAt(0).toUpperCase() + name?.slice(1) : "-";
            },
        },
        {
            header: "Relation",
            accessorKey: "relation",
            enableColumnFilter: false,
            cell: ({ getValue }) => {
                const relation = getValue();
                return relation ? relation?.charAt(0).toUpperCase() + relation?.slice(1) : "-";
            },
        },
        {
            header: "New Brand",
            accessorKey: "isNewBrand",
            enableColumnFilter: false,
            cell: ({ getValue }: any) => {
                const isNewBrand = getValue();
                return isNewBrand ? "Yes" : "No";
            },
        },
        {
            header: "Status",
            accessorKey: "status",
            enableColumnFilter: false,
            cell: ({ row }) => {
                const status = row?.original?.status;
                return status?.charAt(0).toUpperCase() + status?.slice(1);
            },
        }
        
        // {
        //     header: "Action",
        //     cell: (cellProps: any) => {
        //         const otherPartnerData = cellProps.row.original;

        //         return (
        //             <ul className="list-inline hstack gap-2 mb-0">
        //                 <li className="list-inline-item">
        //                     <Link
        //                         to={`/partner-detail/${otherPartnerData._id}`}
        //                         state={{ otherPartner_Id: otherPartnerData._id }}
        //                         className="text-primary d-inline-block"
        //                     >
        //                         <img src={ViewIcon} alt="" style={{ width: "20px", height: "20px" }} />
        //                     </Link>
        //                 </li>
        //             </ul>
        //         );
        //     },
        //     accessorKey: "action",
        //     enableColumnFilter: false,
        // },
    ], []);

    const onFetchData = async (params: any) => {
        const res = await dispatch(getSellerBrandThunk({
            page: params.pageIndex,
            count: params.pageSize,
            status: activeTab,
            keyword: params.searchQuery,
            relation: "",
        }));
        return res.payload;
    };

    document.title = "Brands | BuyPass";

    return (
        <div className="page-content">
            <ToastContainer closeButton={false} limit={1} />
            <Container fluid>
                {/* <BreadCrumb
                    pageTitle="Products"
                    pageTitleLink="/Brand Management "
                    title="Brand Management"
                    titleLink="/manage-products"
                /> */}

                 <BreadCrumb title="Brand Management" pageTitle="Products" pageTitleRoute="/manage-products" />

                <Row>

                    <Col xl={12} lg={12}>
                        <div>
                            <Card>
                                <div className="card-header border-0">
                                    <Row className=" align-items-center">

                                        <Col>
                                            <Nav
                                                className="nav-tabs-custom card-header-tabs border-bottom-0 align-items-center justify-content-between"
                                                role="tablist"
                                            >
                                                <div className="d-flex align-items-center ">
                                                    <NavItem>
                                                        <NavLink
                                                            className={classnames(
                                                                { active: activeTab === "all" },
                                                                "fw-semibold"
                                                            )}
                                                            onClick={() => {
                                                                toggleTab("all", "all");
                                                            }}
                                                            href="#"
                                                            data-testing-id="allActiveButton_otherPartner"
                                                        >
                                                            All{" "}
                                                            <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                                                                {counts.all}

                                                            </span>
                                                        </NavLink>
                                                    </NavItem>
                                                    <NavItem>
                                                        <NavLink
                                                            className={classnames(
                                                                { active: activeTab === "active" },
                                                                "fw-semibold"
                                                            )}
                                                            onClick={() => {
                                                                toggleTab("active", "active");
                                                            }}
                                                            href="#"
                                                            data-testing-id="ActiveButton_otherPartner"
                                                        >
                                                            Active{" "}
                                                            <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                                                                {counts.active}
                                                            </span>
                                                        </NavLink>
                                                    </NavItem>
                                                    <NavItem>
                                                        <NavLink
                                                            className={classnames(
                                                                { active: activeTab === "inactive" },
                                                                "fw-semibold"
                                                            )}
                                                            onClick={() => {
                                                                toggleTab("inactive", "inactive");
                                                            }}
                                                            href="#"
                                                            data-testing-id="inactiveButton_otherPartner"
                                                        >
                                                            In Active
                                                            <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                                                                {counts.inactive}
                                                            </span>
                                                        </NavLink>
                                                    </NavItem>
                                                    <NavItem>
                                                        <NavLink
                                                            className={classnames(
                                                                { active: activeTab === "pending" },
                                                                "fw-semibold"
                                                            )}
                                                            onClick={() => {
                                                                toggleTab("pending", "pending");
                                                            }}
                                                            href="#"
                                                            data-testing-id="pendingButton_otherPartner"
                                                        >
                                                            Pending
                                                            <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                                                                {counts.pending}
                                                            </span>
                                                        </NavLink>
                                                    </NavItem>


                                                </div>
                                            </Nav>
                                        </Col>
                                    </Row>
                                </div>
                                <div className="card-body pt-0">
                                    <PaginatedTable
                                        key={tableKey}
                                        divClass="table-responsive mb-1"
                                        tableClass="mb-0 align-middle table-borderless"
                                        theadClass="table-light text-muted"
                                        columns={columns}
                                        fetchData={(params) => onFetchData(params)}
                                    ></PaginatedTable>
                                </div>
                            </Card>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Brands;
